import { useMemo } from 'react';
import { useFeatureValue } from '@shared/core/featureFlags';

/*
 * Interface for the ShortlistReleasedPayload remote feature flag payload.
 */
interface ShortlistReleasedPayload {
  dateTime: string;
}

/*
 * Type predicate function to validate the ShortlistReleasedPayload remote feature flag payload.
 * @param {any} payload - The payload to validate.
 * @returns {boolean}
 */
export const isShortlistReleasedPayload = (payload: unknown): payload is ShortlistReleasedPayload => {
  return !!(payload && typeof payload === 'object' && 'dateTime' in payload && typeof payload.dateTime === 'string');
};

// Fallback content if we do not get content from the remote feature flag.
// Default is approx 6am PST / 9am EST, Thu March 7
const DEFAULT_SHORTLIST_RELEASED_PAYLOAD = {
  dateTime: '2024-03-07T14:04:58.397Z'
};

/*
 * Hook to retrieve and validate the remote feature flag value for ShortlistReleasedPayload.
 */
export function useShortlistReleasedPayload(): { shortlistIsReleasedPayload: { dateTime: string }; loading: boolean } {
  const { payload: shortlistReleasedPayload, loading } = useFeatureValue('shortlistReleased');
  const shortlistIsReleasedPayload = useMemo(() => {
    return isShortlistReleasedPayload(shortlistReleasedPayload)
      ? {
          dateTime: shortlistReleasedPayload.dateTime
        }
      : DEFAULT_SHORTLIST_RELEASED_PAYLOAD;
  }, [shortlistReleasedPayload]);
  return { shortlistIsReleasedPayload, loading };
}
